import React, { forwardRef } from 'react';
import { View, Text, TextInput, StyleSheet, TextStyle, ViewStyle, TextInputProps } from 'react-native';

interface CurrencyInputProps extends Omit<TextInputProps, 'style'> {
  containerStyle?: ViewStyle;
  currencySymbolStyle?: TextStyle;
  inputStyle?: TextStyle;
  /** When true, applies errorContainerStyle on top of containerStyle */
  hasError?: boolean;
  errorContainerStyle?: ViewStyle;
}

/**
 * Shared currency input: "$" symbol + TextInput in a row container.
 * Bakes in overflow: 'hidden' and minWidth: 0 to prevent the web
 * <input> default min-width from overflowing narrow containers.
 */
export const CurrencyInput = forwardRef<TextInput, CurrencyInputProps>(
  (
    {
      containerStyle,
      currencySymbolStyle,
      inputStyle,
      hasError,
      errorContainerStyle,
      ...textInputProps
    },
    ref,
  ) => {
    return (
      <View
        style={[
          styles.container,
          containerStyle,
          hasError && errorContainerStyle,
        ]}
      >
        <Text style={[styles.currencySymbol, currencySymbolStyle]}>$</Text>
        <TextInput
          ref={ref}
          style={[styles.input, inputStyle]}
          keyboardType="decimal-pad"
          {...textInputProps}
          inputAccessoryViewID=""
        />
      </View>
    );
  },
);

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    overflow: 'hidden',
  },
  currencySymbol: {},
  input: {
    flex: 1,
    minWidth: 0,
    padding: 0,
  },
});
